/** Ensures only one save-and-lock confirmation popover is open at a time. */
const registry = new Map();

export function requestOpenConfirm(id, onClose) {
  registry.forEach((closeFn, existingId) => {
    if (existingId !== id) closeFn();
  });
  registry.set(id, onClose);
}

export function releaseConfirm(id) {
  registry.delete(id);
}
